var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_1136_27467)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56794 11.8128L4.66491 10.4702L1.05908 22.6576L4.22711 21.0649L5.96212 24.0002L9.56794 11.8128Z",
    fill: "url(#paint0_linear_1136_27467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61125 10.7295L5.33447 11.6223L7.0365 17.8469L8.9597 11.6459L5.61125 10.7295Z",
    fill: "url(#paint1_linear_1136_27467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25122 18.6326L7.39478 19.1584L9.56823 11.8126L9.38199 11.7622L7.25122 18.6326Z",
    fill: "#EAA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.141 10.6006L1.52612 22.4221L2.06997 22.149L5.61113 10.7294L5.141 10.6006Z",
    fill: "url(#paint2_linear_1136_27467)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03648 17.8472L5.41528 23.0745L5.71598 23.5834L7.25117 18.6329L7.03648 17.8472Z",
    fill: "url(#paint3_linear_1136_27467)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03638 17.847L7.25107 18.6328L9.38184 11.7623L8.95957 11.646L7.03638 17.847Z",
    fill: "#BC5A1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0829 8.93359L5.15332 10.1816L8.30324 21.7027L10.2232 18.9167L13.2334 20.4553L10.0829 8.93359Z",
    fill: "url(#paint4_linear_1136_27467)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56787 10.0764L8.58781 21.2901L8.91438 20.8166L5.99338 9.96875L5.56787 10.0764Z",
    fill: "url(#paint5_linear_1136_27467)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77813 9.01074L9.35327 9.11837L12.2736 19.965L12.8 20.2338L9.77813 9.01074Z",
    fill: "url(#paint6_linear_1136_27467)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02634 7.26742L8.85756 7.2164L9.02634 7.16538L14.8354 5.40904L14.426 4.45777L14.0167 3.5065L8.61699 6.21411L8.4605 6.2925L8.54198 6.14194L11.3589 0.947582L10.3701 0.553759L9.382 0.159314L7.55387 5.7475L7.5002 5.90988L7.44782 5.7475L5.62227 0.158691L4.63352 0.552515L3.64411 0.946338L6.45906 6.14132L6.54054 6.29188L6.38405 6.21349L0.985014 3.50339L0.575673 4.45466L0.165686 5.40593L5.97406 7.16476L6.14284 7.21578L5.97406 7.26679L0.165039 9.02251L0.57438 9.97441L0.983721 10.9257L6.3834 8.21744L6.5399 8.13905L6.45842 8.28961L3.64153 13.484L4.63028 13.8784L5.61904 14.2722L7.44653 8.68406L7.5002 8.5223L7.55323 8.68406L9.37812 14.2729L10.3675 13.879L11.3563 13.4852L8.54133 8.29024L8.45985 8.13968L8.61635 8.21807L14.0154 10.9282L14.4247 9.97752L14.8347 9.02624L9.02634 7.26742Z",
    fill: "url(#paint7_radial_1136_27467)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89234 7.81985L8.75654 7.71097L8.93243 7.72528L15.0001 8.21678L14.9962 7.18774L14.9917 6.15807L8.92855 6.69562L8.75266 6.71117L8.88716 6.60167L13.5393 2.82147L12.7795 2.09603L12.0203 1.37123L8.12797 5.87624L8.01481 6.00689L8.02968 5.83767L8.54055 0L7.47031 0.00435507L6.40072 0.00808799L6.95944 5.84202L6.97561 6.01125L6.8618 5.88122L2.93264 1.40544L2.17863 2.13647L1.42526 2.86751L6.10778 6.61225L6.24358 6.7205L6.06769 6.70619L0 6.21469L0.00388001 7.24435L0.00840669 8.2734L6.07222 7.73586L6.24811 7.7203L6.11296 7.8298L1.46082 11.61L2.22066 12.3354L2.98049 13.0602L6.87279 8.55523L6.98531 8.42458L6.97044 8.59381L6.45957 14.4315L7.52981 14.4277L8.5994 14.4234L8.04067 8.59007L8.02451 8.42085L8.13832 8.55025L12.0675 13.026L12.8215 12.295L13.5749 11.5646L8.89234 7.81985Z",
    fill: "url(#paint8_radial_1136_27467)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50017 0.42041C3.59882 0.42041 0.437256 3.46274 0.437256 7.21557C0.437256 10.9684 3.59882 14.0107 7.50017 14.0107C11.4015 14.0107 14.5624 10.9684 14.5624 7.21557C14.5624 3.46274 11.4002 0.42041 7.50017 0.42041Z",
    fill: "url(#paint9_linear_1136_27467)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.720215C3.77066 0.720215 0.748779 3.62878 0.748779 7.21612C0.748779 10.8035 3.77131 13.712 7.5 13.712C11.2287 13.712 14.2512 10.8035 14.2512 7.21612C14.2512 3.62878 11.2287 0.720215 7.5 0.720215Z",
    fill: "url(#paint10_radial_1136_27467)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 2.21552L6.82547 1.03467L6.41871 2.32377L5.50367 1.30406L5.38598 2.64605L4.26983 1.83351L4.44508 3.16928L3.17761 2.59752L3.63739 3.86982L2.27421 3.56248L2.99783 4.71533L1.5978 4.68733L2.55551 5.66971L1.1807 5.92417L2.33047 6.69191L1.04102 7.21576L2.33047 7.73899L1.1807 8.50735L2.55551 8.76181L1.5978 9.74419L2.99783 9.7162L2.27421 10.869L3.63739 10.5617L3.17761 11.834L4.44508 11.2622L4.26918 12.598L5.38598 11.7855L5.50367 13.1275L6.41871 12.1078L6.82547 13.3969L7.49994 12.2166L8.17442 13.3969L8.58182 12.1078L9.49621 13.1275L9.6139 11.7855L10.7307 12.598L10.5548 11.2616L11.8223 11.834L11.3625 10.5617L12.7257 10.869L12.002 9.71557L13.4021 9.74419L12.4444 8.76119L13.8192 8.50735L12.6694 7.73899L13.9589 7.21576L12.6694 6.69191L13.8192 5.92417L12.4444 5.66971L13.4021 4.68733L12.002 4.71595L12.7257 3.56248L11.3625 3.86982L11.8223 2.59752L10.5548 3.1699L10.7307 1.83351L9.6139 2.64605L9.49621 1.30406L8.58182 2.32377L8.17442 1.03467L7.49994 2.21552Z",
    fill: "url(#paint11_radial_1136_27467)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50014 2.47656C4.77896 2.47656 2.57446 4.59811 2.57446 7.21551C2.57446 9.8329 4.7796 11.9551 7.50014 11.9551C10.2207 11.9551 12.4258 9.83353 12.4258 7.21551C12.4258 4.59748 10.22 2.47656 7.50014 2.47656Z",
    fill: "#CC7127"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2781 7.21574C12.2781 9.75475 10.139 11.8128 7.49991 11.8128C4.86086 11.8128 2.72168 9.75475 2.72168 7.21574C2.72168 4.67674 4.86151 2.61865 7.49991 2.61865C10.1383 2.61865 12.2781 4.67674 12.2781 7.21512V7.21574Z",
    fill: "url(#paint12_linear_1136_27467)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1497 7.21596C12.1497 9.68653 10.0681 11.6892 7.50013 11.6892C4.93221 11.6892 2.85059 9.68653 2.85059 7.21596C2.85059 4.74539 4.93221 2.74268 7.50013 2.74268C10.0681 2.74268 12.1497 4.74539 12.1497 7.21596Z",
    fill: "url(#paint13_linear_1136_27467)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9568 7.21548C11.9568 9.5834 9.96184 11.5027 7.50063 11.5027C5.03941 11.5027 3.04443 9.5834 3.04443 7.21548C3.04443 4.84757 5.04005 2.92822 7.50063 2.92822C9.9612 2.92822 11.9568 4.84757 11.9568 7.21548Z",
    fill: "url(#paint14_linear_1136_27467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_27467",
    x1: 4.54266,
    y1: 19.8411,
    x2: 6.34444,
    y2: 13.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9CF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F8CA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F7C70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_27467",
    x1: 8.30785,
    y1: 17.804,
    x2: 7.48228,
    y2: 13.0644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B82B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1136_27467",
    x1: 4.53313,
    y1: 12.9859,
    x2: 2.28822,
    y2: 22.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1136_27467",
    x1: 7.4691,
    y1: 17.4229,
    x2: 6.10696,
    y2: 21.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1136_27467",
    x1: 10.2471,
    y1: 19.2109,
    x2: 8.4862,
    y2: 12.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9CF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F8CA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F7C70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1136_27467",
    x1: 6.70471,
    y1: 13.0907,
    x2: 8.32818,
    y2: 20.7912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1136_27467",
    x1: 10.5315,
    y1: 12.2839,
    x2: 12.155,
    y2: 19.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1136_27467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50744 7.2216) rotate(21.7375) scale(7.45521 7.25164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1136_27467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50797 7.22472) rotate(43.6633) scale(7.3566 7.34884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1136_27467",
    x1: 7.50017,
    y1: 13.2716,
    x2: 7.50017,
    y2: 0.552929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1136_27467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5 7.21612) scale(6.75187 6.4959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1136_27467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.49994 7.21576) scale(6.44146 6.19727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DA811E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E19527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EEB837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7D142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDE049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1136_27467",
    x1: 7.49991,
    y1: 3.00128,
    x2: 7.49991,
    y2: 11.5497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1136_27467",
    x1: 7.50013,
    y1: 11.4379,
    x2: 7.50013,
    y2: 2.87706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1136_27467",
    x1: 7.49998,
    y1: 3.74573,
    x2: 7.49998,
    y2: 10.9776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_27467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0001,
    height: 24.0002,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/gold_badge.4ea0c207d9226a273e29424c76d67e16.svg";
export { ForwardRef as ReactComponent };